<template>
  <!-- NOTE (TEMPLATE) to show the dashboard of the researcher -->
  <div class="animated fadeIn">
    <div v-if="$router.currentRoute.path == '/researcher/dashboard'">
      <BannerSlider :images="banners" :clickable="true" />
    </div>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/researcher/dashboard'"
      bg-variant="white"
      text-variant="dark"
      style="margin: 20px"
    >
      <template v-slot:lead>
        <h2>
          پژوهشگر گرامی، به سامانه طرح تقسیم کار ملی - ستاد زیست فناوری ریاست
          جمهوری خوش آمدید!
        </h2>
        <hr />
        <p>
          به منظور استفاده هر چه بهتر از سامانه خواهشمند است دستورالعمل‌های زیر
          را مطالعه بفرمایید.
        </p>

        <ul>
          <li>
            <b-link
              :href="
                filePath +
                `/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf`
              "
              target="blank"
              >کتاب تقسیم کار ملی زیست فناوری</b-link
            >
          </li>
        </ul>
        <ul>
          <li v-if="profileStatus == 'نیازمند به تکمیل'">
            <!-- NOTE (<a>) to go to the view and complete user profiles page -->
            <a href="/researcher/profile" target="_blank"
              >مشاهده و تکمیل پروفایل کاربری
              <b-badge variant="danger" class="p-2">(مهم)</b-badge></a
            >
          </li>
        </ul>
      </template>
    </b-jumbotron>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/referee/dashboard'"
      bg-variant="light"
      text-variant="dark"
      class="border-0"
    >
      <template v-slot:lead>
        <h1 class="text-center" style="color: #117864">
          داور گرامی، خوش آمدید!
        </h1>
        <br />
        <hr />
        <div class="container">
          <div class="containerSq">
            <div class="boxSq">
              <div class="boxContentSq">
                <i class="fa fa-tasks icon"></i>
                <h1 class="title">داوری‌ها</h1>
              </div>
              <router-link to="reviews"></router-link>
            </div>
            <div class="boxSq">
              <div class="boxContentSq">
                <i class="fa fa-archive icon"></i>
                <h1 class="title">آرشیو داوری‌ها</h1>
              </div>
              <router-link to="archive"></router-link>
            </div>
            <div class="boxSq">
              <div class="boxContentSq">
                <i class="fa fa-book icon"></i>
                <h1 class="title">گزارش‌</h1>
              </div>
              <router-link to="projectsControl"></router-link>
            </div>
          </div>
        </div>
      </template>
    </b-jumbotron>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/manager/dashboard'"
      bg-variant="primary"
      text-variant="white"
    >
      <template v-slot:lead>
        <h1>رییس گروه گرامی، خوش آمدید!</h1>
        <br />
        <h4>
          در این نسخه، شما به تمامی نقش‌ها و عملکردهای ایشان دسترسی دارید و
          میتوانید صفحات و عملکردهای هر نقش را از منوی سمت راست مشاهده و آزمایش
          نمایید.
        </h4>
        <h4>
          پس از تایید عملیات و بارگذاری سیستم اصلی، هر نفر تنها به منوهایی
          دسترسی خواهد داشت که در سیستم برای وی تعریف شده است.
        </h4>
      </template>
    </b-jumbotron>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/admin/dashboard'"
      bg-variant="light"
      text-variant="dark"
      class="p-0 pb-4"
    >
      <template v-slot:lead>
        <h1 class="text-center pt-3" style="color: #1f618d">
          ادمین گرامی، خوش آمدید!
        </h1>
      </template>
      <hr />

      <div class="admin-container">
        <div class="admin-containerSq">
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-tasks admin-icon"></i>
              <h1 class="admin-title">گزارش‌ پیشرفته</h1>
            </div>
            <router-link to="advancedReport"></router-link>
          </div>
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-plus admin-icon"></i>
              <h1 class="admin-title">ثبت سریع</h1>
            </div>
            <router-link to="fastSubmission"></router-link>
          </div>
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-book admin-icon"></i>
              <h1 class="admin-title">موضوع‌ها و محورها</h1>
            </div>
            <router-link to="topics"></router-link>
          </div>
        </div>
      </div>
      <div class="admin-container">
        <div class="admin-containerSq">
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-users admin-icon"></i>
              <h1 class="admin-title">پژوهشگران</h1>
            </div>
            <router-link to="users"></router-link>
          </div>
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-users admin-icon"></i>
              <h1 class="admin-title">داوران</h1>
            </div>
            <router-link to="reviewers"></router-link>
          </div>
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-university admin-icon"></i>
              <h1 class="admin-title">دانشگاه‌ها</h1>
            </div>
            <router-link to="universities"></router-link>
          </div>
        </div>
      </div>
    </b-jumbotron>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/head/dashboard'"
      bg-variant="light"
      text-variant="dark"
      class="p-0 pb-4"
    >
      <template v-slot:lead>
        <h1 class="text-center pt-3" style="color: #1f618d">
          ادمین ناظر گرامی، خوش آمدید!
        </h1>
      </template>
      <hr />

      <div class="admin-container">
        <div class="admin-containerSq">
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-tasks admin-icon"></i>
              <h1 class="admin-title">گزارش‌ پیشرفته</h1>
            </div>
            <router-link to="advancedReport"></router-link>
          </div>

          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-book admin-icon"></i>
              <h1 class="admin-title">موضوع‌ها و محورها</h1>
            </div>
            <router-link to="topics"></router-link>
          </div>
        </div>
      </div>
      <div class="admin-container">
        <div class="admin-containerSq">
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-users admin-icon"></i>
              <h1 class="admin-title">پژوهشگران</h1>
            </div>
            <router-link to="users"></router-link>
          </div>
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-users admin-icon"></i>
              <h1 class="admin-title">داوران</h1>
            </div>
            <router-link to="reviewers"></router-link>
          </div>
          <div class="admin-boxSq">
            <div class="admin-boxContentSq">
              <i class="fa fa-university admin-icon"></i>
              <h1 class="admin-title">دانشگاه‌ها</h1>
            </div>
            <router-link to="universities"></router-link>
          </div>
        </div>
      </div>
    </b-jumbotron>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/university/dashboard'"
      bg-variant="light"
      text-variant="dark"
      class="border-0"
    >
      <template v-slot:lead>
        <h1>دانشگاه گرامی، خوش آمدید!</h1>
        <br />
        <h4>
          در این نسخه، شما به تمامی نقش‌ها و عملکردهای دانشگاهی دسترسی دارید و
          میتوانید صفحات و عملکردهای نقش خود را از منوی سمت راست مشاهده نمایید.
        </h4>
      </template>
    </b-jumbotron>
    <b-jumbotron
      v-if="$router.currentRoute.path == '/companyManager/dashboard'"
      bg-variant="light"
      text-variant="dark"
      class="border-0"
    >
      <template v-slot:lead>
        <h1>ادمین شرکت گرامی، خوش آمدید!</h1>
        <br />
        <h4>
          شما میتوانید از منوی سمت راست به کلیه شرکت‌ها دسترسی داشته باشید و
          مدیریت آنها را انجام دهید.
        </h4>
      </template>
    </b-jumbotron>
    <router-view></router-view>
  </div>
</template>

<script>
import BannerSlider from "./BannerSlider.vue";
export default {
  components: { BannerSlider },
  data() {
    return {
      profileStatus: "",
      minVer: 0,
      role: "",
      banners: [],
    };
  },

  methods: {
    checkRole() {
      if (this.role == "researcher") {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/researcher",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.profileStatus = res.data.status;
            this.$http
              .get(this.baseUrl + "/setad/authentication/banners/")
              .then((res) => {
                this.banners = res.data;
              })
              .catch((err) => {
                console.log(err);
                this.toast(err.response.data, "error");
              });
          })
          .catch((err) => {
            if (err.response.status == 403)
              // this.$router.replace("/unauthorize");
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          });
      } else if (this.role == "referee") {
        this.$http
          .post(
            this.baseUrl + "/setad/referee/referee",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then(() => {})
          .catch((err) => {
            if (err.response.status == 403)
              // this.$router.replace("/unauthorize");
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          });
      } else if (this.role == "university") {
        this.$http
          .post(
            this.baseUrl + "/setad/university/university",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then(() => {})
          .catch((err) => {
            if (err.response.status == 403)
              // this.$router.replace("/unauthorize");
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          });
      } else if (this.role == "admin") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/adminAdmin",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then(() => {})
          .catch((err) => {
            if (err.response.status == 403)
              // this.$router.replace("/unauthorize");
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          });
      } else if (this.role == "manager") {
        this.$http
          .post(
            this.baseUrl + "/setad/manager/adminManager",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then(() => {})
          .catch((err) => {
            if (err.response.status == 403)
              // this.$router.replace("/unauthorize");
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          });
      }
    },
  },
  mounted() {
    // NOTE (mountedD) check the validity of current user's token
    this.role = localStorage.getItem("role");
    this.checkRole();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style lang="scss" scoped>
/*###### REFEREE DASHBOARD #######*/
.container {
  display: flex;
  justify-content: space-around;
  align-items: top;
  flex-wrap: wrap;
  height: 90%;
}
.containerSq {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  height: 90%;

  .boxSq {
    width: 230px;
    height: 180px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    background-color: #d0dbd5;
    margin: 28px;
    transition: 0.3s all ease-in-out;
    position: relative;
    box-shadow: 0px 0px 15px #117864;

    &:hover {
      background: linear-gradient(210deg, #0e6655 0%, #52be80 100%);
      box-shadow: none;
    }

    a {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .boxContentSq {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 45px;
      .desc {
        color: #117864;
        font-size: 15px;
        height: 20%;
      }
      .icon {
        color: #117864;
        font-size: 48px;
        padding: 15px;
      }
      .title {
        font-size: 24px;
        color: #117864;
        font-weight: bold;
        padding: 10px;
      }
    }
  }
}

.containerSq .boxSq:hover .icon,
.containerSq .boxSq:hover .title,
.containerSq .boxSq:hover .desc {
  color: white;
  transition: 0.3s all ease-in-out;
}
/*###### REFEREE DASHBOARD #######*/
/*//////////////////////////////////
/*####### ADMIN DASHBOARD ########*/
.admin-container {
  @extend .container;
}
.admin-containerSq {
  @extend .containerSq;

  .admin-boxSq {
    width: 230px;
    height: 180px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    background-color: #eaf2f8;
    margin: 28px;
    transition: 0.3s all ease-in-out;
    position: relative;
    box-shadow: 0px 0px 15px #1f618d;

    a {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    &:hover {
      background: linear-gradient(200deg, #154360 0%, #5499c7 100%);
      box-shadow: none;
    }
    .admin-boxContentSq {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 45px;
      .admin-icon {
        color: #1f618d;
        font-size: 48px;
        padding: 15px;
      }
      .admin-title {
        font-size: 24px;
        color: #1f618d;
        font-weight: bold;
        padding: 10px;
      }
      .admin-desc {
        color: #1f618d;
        font-size: 15px;
        height: 20%;
      }
    }
  }
}

.admin-containerSq .admin-boxSq:hover .admin-icon,
.admin-containerSq .admin-boxSq:hover .admin-title,
.admin-containerSq .admin-boxSq:hover .admin-desc {
  color: white;
  transition: 0.3s all ease-in-out;
}
/*####### ADMIN DASHBOARD ########*/
</style>
